import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-addsubledgertype',
  templateUrl: './addsubledgertype.component.html',
  styleUrls: ['./addsubledgertype.component.css']
})
export class AddsubledgertypeComponent implements OnInit{

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  accountid: any = []

  subledgertypedetailsColl: any = [];
  //Edit Get Values
  subledgertypeColl: any = [];
  accountColl: any = [];

  subledgertypeform = new FormGroup({
    subledgertypeid: new FormControl(0),
    subledgertypename: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "SubledgerType";

  @Input() subledgertypeid: number = 0
  @Input() subledgertypename: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  ngAfterViewInit(){
 
    this.loginService.fnSetFirstControlFocus('subledgertypename');
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.subledgertypeform.reset();
      this.fnInitializeSubledgertype();

      if (this.subledgertypeid > 0) {
        this.fngetSubledgertype();
      }
      this.fngetAccount()
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.subledgertypeid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
    //this.isadjtypeaddmode = this.loginService.fnCheckUserRoleAction("AdjType", 'CREATE')
    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeSubledgertype() {
    this.subledgertypeform.setValue({

      subledgertypeid: 0,
      subledgertypename: '',
      inactive:false,
    })
  }

  fngetAccount() {
    var data = {
      'accountid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),     
    }
    this.appService.getAccount(data)
      .subscribe(
        (res) => {

          var result = res.json().result;
          this.accountColl = result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetSubledgertype() {
   
    var data = {
      'subledgertypeid': this.subledgertypeid,
      'companyid': this.loginService.fnGetCompanyId(),
      'organizationid': this.loginService.fnGetOrganizationId(),
    }
    this.appService.getSubledgerType(data)
      .subscribe(
        (res) => {
          console.log(res.json())
          this.subledgertypeColl = res.json().result[0];
          var editdata = this.subledgertypeColl[0];
          this.fnEditMode(editdata);

          
          this.subledgertypedetailsColl= res.json().result[1];

          this.fnGetSubledgerDetails()
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      this.fnSetSubledgerDetails()
      if (this.saveloading) {
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.subledgertypeform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'subledgertypeid': this.subledgertypeid,
          'subledgertypename': this.subledgertypeform.get('subledgertypename').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'organizationid': this.loginService.fnGetOrganizationId(),
          'inactive': this.subledgertypeform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
          'subledgertypedetailscoll':this.subledgertypedetailsColl
        }
      
        this.appService.fnCheckSubledgerType(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.subledgertypeform.get('subledgertypeid').value > 0) {
                //Update Department
                this.fnSetSubledgertype(data);
              }
              else {
                //Insert Department
                this.fnInsertSubledgertype(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.subledgertypeform.controls['subledgertypename'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertSubledgertype(data) {
  
    this.appService.fnInsertSubledgerType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnsubledgertypeid = 0;
          if (result.length > 0) {
            rtnsubledgertypeid = result[0].subledgertypeid
           
          }
          this.toastr.success('', "The new subledgertype has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.subledgertypeid);

          this.emitData.emit(rtnsubledgertypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetSubledgertype(data) {

    this.appService.fnSetSubledgerType(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status==200) {
          this.toastr.success('', "The subledgertype has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.subledgertypeid, data.subledgertypename);

          this.emitData.emit(this.subledgertypeid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.subledgertypeform.setValue({

      subledgertypeid: deptBO.subledgertypeid,
      subledgertypename: deptBO.subledgertypename,     
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }

  fnSetSubledgerDetails(){
    this.subledgertypedetailsColl=[]
    for(let abo of this.accountid){
      var ss={
        'accountid':abo
      }
      this.subledgertypedetailsColl.push(ss)
    }
    
  }


  fnGetSubledgerDetails(){

    this.accountid=[]
    for(let abo of this.subledgertypedetailsColl){
     
      this.accountid.push(abo.accountid)
    }
    
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}

